import { useState } from "react";
import { Pause, Play } from "lucide-react";

const WORDS = ["Identification of need", "Graduated approach", "Assess · Plan · Do · Review", "EHCP timeliness", "Parent voice", "Governor oversight", "Staff confidence", "Outcomes that matter"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {WORDS.map((w) => (
      <span key={w} className="flex items-center whitespace-nowrap px-6 font-display text-3xl italic sm:text-5xl">
        {w}
        <svg viewBox="0 0 24 24" className="ml-12 h-6 w-6 text-sun" aria-hidden="true"><path fill="currentColor" d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const [paused, setPaused] = useState(false);
  return (
    <section aria-label="SEND principles" className={`relative overflow-hidden border-y border-line bg-brand py-7 text-brand-fg ${paused ? "marquee-paused" : ""}`}>
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
      <button type="button" onClick={() => setPaused((p) => !p)} data-testid="marquee-pause"
        aria-label={paused ? "Play scrolling text" : "Pause scrolling text"}
        className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-sun text-sun-fg">
        {paused ? <Play size={16} aria-hidden /> : <Pause size={16} aria-hidden />}
      </button>
    </section>
  );
};
